const productData = [
  {
    id: 1,
    name: "Meadow Orbit Studs",
    category: "Earrings",
    price: "38.00",
    reviews: "342",
    rating: "4.6",
    image: "/img/mefurvexo-01-front.png",
    images: ["/img/mefurvexo-01-front.png", "/img/mefurvexo-01-angle.png"],
    material: "925 Sterling Silver",
    description: [
      "An original openwork wildflower design with softly uneven petals and a polished centre bead.",
      "Crafted from premium 925 sterling silver for timeless beauty and durability.",
      "Lightweight and comfortable for all-day wear, perfect for both casual and formal occasions.",
      "The airy radial form brings an easy, nature-led accent to everyday styling.",
      "Hand-finished with meticulous attention to detail by our skilled artisans.",
    ],
    Features: [
      "925 Sterling Silver construction",
      "Original openwork wildflower design",
      "Secure push-back closure",
      "Lightweight and comfortable",
      "Hypoallergenic for sensitive ears",
      "Handcrafted finish",
    ],
  },
  {
    id: 2,
    name: "Offset Trio Studs",
    category: "Earrings",
    price: "38.00",
    reviews: "289",
    rating: "4.7",
    image: "/img/mefurvexo-02-front.png",
    images: ["/img/mefurvexo-02-front.png", "/img/mefurvexo-02-angle.png"],
    material: "925 Sterling Silver",
    description: [
      "Three slim, rounded silver bars meet in a subtly offset geometric form.",
      "Sleek, clean lines and a polished finish create a timeless everyday essential.",
      "Versatile enough to wear alone or layer with other earrings for a curated look.",
      "Precision-crafted from premium sterling silver for exceptional quality and shine.",
      "Perfect for those who appreciate understated elegance and contemporary design.",
    ],
    Features: [
      "925 Sterling Silver material",
      "Original offset three-bar design",
      "Polished finish for maximum shine",
      "Comfortable push-back closure",
      "Hypoallergenic properties",
      "Suitable for everyday wear",
    ],
  },
  {
    id: 3,
    name: "Soft Square Huggies",
    category: "Earrings",
    price: "47.00",
    reviews: "214",
    rating: "4.5",
    image: "/img/mefurvexo-03-front.png",
    images: ["/img/mefurvexo-03-front.png", "/img/mefurvexo-03-angle.png"],
    material: "925 Sterling Silver",
    description: [
      "A softly squared outer profile gives these compact huggies a distinctive modern line.",
      "Snug, comfortable fit that hugs the earlobe perfectly for all-day wear.",
      "Crafted with precision from premium sterling silver for lasting beauty and durability.",
      "Versatile enough to wear from day to night, pairing beautifully with any ensemble.",
      "Timeless design that makes them a staple in any jewellery collection.",
    ],
    Features: [
      "925 Sterling Silver construction",
      "Softly squared huggie profile",
      "Secure hinged closure",
      "Comfortable, snug fit",
      "Polished, reflective finish",
      "Hypoallergenic and nickel-free",
    ],
  },
  {
    id: 4,
    name: "Tidal Spiral Threaders",
    category: "Earrings",
    price: "38.00",
    reviews: "178",
    rating: "4.6",
    image: "/img/mefurvexo-04-front.png",
    images: ["/img/mefurvexo-04-front.png", "/img/mefurvexo-04-angle.png"],
    material: "925 Sterling Silver",
    description: [
      "An original asymmetrical spiral ribbon flows into a fine pull-through tail.",
      "Innovative and eye-catching, these earrings make a subtle yet memorable statement.",
      "Fluid, organic lines that draw inspiration from natural forms and movement.",
      "Easy to wear with a secure pull-through mechanism that stays comfortably in place.",
      "Crafted with meticulous attention to detail from premium sterling silver.",
    ],
    Features: [
      "925 Sterling Silver material",
      "Original tidal spiral design",
      "Pull-through style closure",
      "Lightweight construction",
      "Organic, flowing lines",
      "Hypoallergenic finish",
    ],
  },
  {
    id: 5,
    name: "Compass Spark Threaders",
    category: "Earrings",
    price: "38.00",
    reviews: "305",
    rating: "4.8",
    image: "/img/mefurvexo-05-front.png",
    images: ["/img/mefurvexo-05-front.png", "/img/mefurvexo-05-angle.png"],
    material: "925 Sterling Silver",
    description: [
      "Delicate threaders finished with an original four-point compass spark.",
      "Elegant and ethereal, these earrings add a touch of celestial beauty to any look.",
      "Long, flowing design that creates movement and catches the light beautifully.",
      "Versatile styling options - wear them long or double them up for a different effect.",
      "Perfect for adding a subtle, romantic touch to both casual and formal outfits.",
    ],
    Features: [
      "925 Sterling Silver construction",
      "Delicate threader design",
      "Four-point compass spark detail",
      "Lightweight and comfortable",
      "Versatile styling possibilities",
      "Hypoallergenic properties",
    ],
  },
  {
    id: 6,
    name: "Ellipse Line Huggies",
    category: "Earrings",
    price: "61.00",
    reviews: "198",
    rating: "4.4",
    image: "/img/mefurvexo-06-front.png",
    images: ["/img/mefurvexo-06-front.png", "/img/mefurvexo-06-angle.png"],
    material: "925 Sterling Silver",
    description: [
      "Slim oval huggies are shaped with a shallow sculpted groove along the outer face.",
      "Perfectly proportioned for everyday elegance, adding subtle shine to any outfit.",
      "Premium sterling silver construction ensures lasting quality and timeless appeal.",
      "Comfortable hinged design that's easy to put on and secure to wear all day.",
      "A classic piece that transitions seamlessly from casual to formal occasions.",
    ],
    Features: [
      "925 Sterling Silver material",
      "Slim oval huggie profile",
      "Delicate, refined finish",
      "Secure hinged closure",
      "Perfect everyday size",
      "Hypoallergenic and nickel-free",
    ],
  },
  {
    id: 7,
    name: "Garnet Orbit Heart Hoops",
    category: "Earrings",
    price: "112.00",
    reviews: "240",
    rating: "4.7",
    image: "/img/mefurvexo-07-front.png",
    images: ["/img/mefurvexo-07-front.png", "/img/mefurvexo-07-angle.png"],
    material: "Gold Vermeil over 925 Sterling Silver with Garnet",
    description: [
      "An asymmetrical open-heart drop holds a deep-red garnet in an offset bezel.",
      "Garnet, known as the stone of love and commitment, adds a vibrant pop of color.",
      "Gold vermeil finish provides the luxurious look of solid gold at an accessible price point.",
      "Perfect for special occasions, anniversaries, or as a meaningful gift for someone special.",
      "Each piece is meticulously crafted to showcase the beauty of the garnet stones.",
    ],
    Features: [
      "Gold Vermeil over 925 Sterling Silver",
      "Genuine garnet gemstones",
      "Original offset heart-drop design",
      "Secure hinged closure",
      "Rich red garnet color",
      "Hypoallergenic properties",
    ],
  },
  {
    id: 8,
    name: "Three-Tide Huggies",
    category: "Earrings",
    price: "56.00",
    reviews: "190",
    rating: "4.8",
    image: "/img/mefurvexo-08-front.png",
    images: ["/img/mefurvexo-08-front.png", "/img/mefurvexo-08-angle.png"],
    material: "925 Sterling Silver",
    description: [
      "Three softly undulating ridges bring a water-inspired rhythm to compact silver huggies.",
      "Subtle yet distinctive, the ripple pattern catches light beautifully from every angle.",
      "Perfect balance between minimalism and intricate detail for everyday sophistication.",
      "Comfortable hinged design that sits securely on the earlobe throughout the day.",
      "Versatile enough to wear alone or pair with other earrings for a curated look.",
    ],
    Features: [
      "925 Sterling Silver construction",
      "Three-ridge tidal texture",
      "Huggie hoop style",
      "Secure hinged closure",
      "Lightweight and comfortable",
      "Hypoallergenic finish",
    ],
  },
  {
    id: 9,
    name: "Twisted Horizon Huggies",
    category: "Earrings",
    price: "75.00",
    reviews: "256",
    rating: "4.7",
    image: "/img/mefurvexo-09-front.png",
    images: ["/img/mefurvexo-09-front.png", "/img/mefurvexo-09-angle.png"],
    material: "925 Sterling Silver",
    description: [
      "A continuous twisted-rope edge gives these medium huggies texture and dimension.",
      "Perfectly proportioned for noticeable yet comfortable everyday wear.",
      "Classic design that transcends trends, making them a lasting addition to any collection.",
      "Premium sterling silver construction ensures durability and lasting shine.",
      "Ideal for both personal enjoyment and as a thoughtful, meaningful gift.",
    ],
    Features: [
      "925 Sterling Silver material",
      "Medium huggie hoop size",
      "Original twisted-edge design",
      "Secure hinged closure",
      "Versatile everyday wear",
      "Hypoallergenic properties",
    ],
  },
  {
    id: 10,
    name: "Blush Orbit Heart Hoops",
    category: "Earrings",
    price: "103.00",
    reviews: "312",
    rating: "4.9",
    image: "/img/mefurvexo-10-front.png",
    images: ["/img/mefurvexo-10-front.png", "/img/mefurvexo-10-angle.png"],
    material: "Gold Vermeil over 925 Sterling Silver with Pink Tourmaline",
    description: [
      "Rounded open-heart drops hold pale-pink tourmalines in gently offset bezels.",
      "Pink tourmaline, the stone of compassion and emotional healing, adds a soft, feminine touch.",
      "Gold vermeil finish creates a luxurious, warm glow that complements the pink tourmaline perfectly.",
      "Perfect for romantic occasions, Valentine's Day, or as a special gift for someone you love.",
      "Each piece is carefully crafted to highlight the natural beauty of the tourmaline stones.",
    ],
    Features: [
      "Gold Vermeil over 925 Sterling Silver",
      "Genuine pink tourmaline gemstones",
      "Original blush heart-drop design",
      "Secure hinged closure",
      "Soft pink tourmaline color",
      "Hypoallergenic construction",
    ],
  },
  {
    id: 11,
    name: "Whisper Wave Huggies",
    category: "Earrings",
    price: "47.00",
    reviews: "198",
    rating: "4.6",
    image: "/img/mefurvexo-11-front.png",
    images: ["/img/mefurvexo-11-front.png", "/img/mefurvexo-11-angle.png"],
    material: "925 Sterling Silver",
    description: [
      "Micro huggies carry a single fine wave around the outer edge for quiet texture.",
      "Perfect for those who prefer minimal, understated jewellery that still has character.",
      "The tiny ripple pattern adds dimension and catches light in a beautiful, understated way.",
      "Ideal for second piercings or for creating a curated ear stack with other pieces.",
      "Comfortable enough to wear 24/7, including while sleeping.",
    ],
    Features: [
      "925 Sterling Silver construction",
      "Micro huggie hoop size",
      "Single engraved wave detail",
      "Secure hinged closure",
      "Perfect for stacking",
      "Hypoallergenic finish",
    ],
  },
  {
    id: 12,
    name: "Orbit Cluster Studs",
    category: "Earrings",
    price: "38.00",
    reviews: "267",
    rating: "4.5",
    image: "/img/mefurvexo-12-front.png",
    images: ["/img/mefurvexo-12-front.png", "/img/mefurvexo-12-angle.png"],
    material: "925 Sterling Silver",
    description: [
      "An open silver orbit gathers three polished spheres and one asymmetrical spark.",
      "Intricate design evokes stars, nebulae, and the infinite wonder of space.",
      "Perfect for those who love astronomy, astrology, or simply feel a connection to the stars.",
      "Versatile enough for everyday wear while adding a touch of cosmic magic to any outfit.",
      "Meticulously crafted from premium sterling silver for lasting quality and shine.",
    ],
    Features: [
      "925 Sterling Silver material",
      "Original orbit-cluster design",
      "Secure push-back closure",
      "Lightweight and comfortable",
      "Intricate detailing",
      "Hypoallergenic properties",
    ],
  },
  {
    id: 13,
    name: "Northlight Six-Point Studs",
    category: "Earrings",
    price: "38.00",
    reviews: "223",
    rating: "4.6",
    image: "/img/mefurvexo-13-front.png",
    images: ["/img/mefurvexo-13-front.png", "/img/mefurvexo-13-angle.png"],
    material: "925 Sterling Silver",
    description: [
      "A softly domed six-point star alternates long and short rays for an original silhouette.",
      "Classic star design that symbolizes hope, guidance, and dreams reaching for the sky.",
      "Timeless and versatile, these studs complement any style from casual to elegant.",
      "Perfect on their own or paired with other earrings for a celestial-themed ear stack.",
      "Crafted with precision from premium sterling silver for lasting beauty and durability.",
    ],
    Features: [
      "925 Sterling Silver construction",
      "Original six-point star design",
      "Secure push-back closure",
      "Timeless and versatile",
      "Celestial symbolism",
      "Hypoallergenic finish",
    ],
  },
  {
    id: 14,
    name: "Peridot Halo Studs",
    category: "Earrings",
    price: "38.00",
    reviews: "198",
    rating: "4.7",
    image: "/img/mefurvexo-14-front.png",
    images: ["/img/mefurvexo-14-front.png", "/img/mefurvexo-14-angle.png"],
    material: "Gold Vermeil over 925 Sterling Silver with Peridot",
    description: [
      "Vivid green peridot stones sit inside clean four-prong settings and delicate offset halos.",
      "Peridot's lush green color brings a fresh, vibrant energy to any ensemble.",
      "Gold vermeil setting provides a warm, luxurious backdrop that makes the peridot truly shine.",
      "Perfect for August birthdays, as peridot is the traditional birthstone for this month.",
      "Delicate enough for everyday wear while adding a pop of color and sophistication.",
    ],
    Features: [
      "Gold Vermeil over 925 Sterling Silver",
      "Genuine peridot gemstones",
      "Delicate stud design",
      "Secure push-back closure",
      "Vibrant green color",
      "Hypoallergenic properties",
    ],
  },
  {
    id: 15,
    name: "Longline Oval Hoops",
    category: "Earrings",
    price: "84.00",
    reviews: "312",
    rating: "4.8",
    image: "/img/mefurvexo-15-front.png",
    images: ["/img/mefurvexo-15-front.png", "/img/mefurvexo-15-angle.png"],
    material: "925 Sterling Silver",
    description: [
      "Large fine hoops use an elongated oval profile and a subtly flattened outer edge.",
      "Perfectly proportioned for bold yet sophisticated style that commands attention.",
      "Premium sterling silver construction with a polished finish for maximum shine.",
      "Versatile enough to elevate casual outfits or complete formal evening looks.",
      "Timeless design that will remain a staple in your jewellery collection for years to come.",
    ],
    Features: [
      "925 Sterling Silver material",
      "Elongated oval hoop profile",
      "Polished, fine finish",
      "Secure hinged closure",
      "Statement-making design",
      "Hypoallergenic construction",
    ],
  },
  {
    id: 16,
    name: "Five Pearl Drift Bracelet",
    category: "Bracelets",
    price: "66.00",
    reviews: "187",
    rating: "4.7",
    image: "/img/mefurvexo-16-front.png",
    images: ["/img/mefurvexo-16-front.png", "/img/mefurvexo-16-angle.png"],
    material: "925 Sterling Silver with Freshwater Pearls",
    description: [
      "Five irregular freshwater pearls drift along a fine silver chain with tiny bead spacers.",
      "Each pearl is unique, with natural iridescence that evokes the ocean's mystical beauty.",
      "Perfect for those who feel a connection to the sea and love romantic, ethereal jewellery.",
      "Delicate enough for everyday wear while adding a touch of whimsical elegance.",
      "Crafted with care from premium sterling silver and genuine freshwater pearls.",
    ],
    Features: [
      "925 Sterling Silver construction",
      "Genuine freshwater pearls",
      "Original five-pearl spacing",
      "Delicate and elegant",
      "Natural pearl iridescence",
      "Hypoallergenic properties",
    ],
  },
  {
    id: 17,
    name: "Onyx Comet Drop Huggies",
    category: "Earrings",
    price: "121.00",
    reviews: "234",
    rating: "4.6",
    image: "/img/mefurvexo-17-front.png",
    images: ["/img/mefurvexo-17-front.png", "/img/mefurvexo-17-angle.png"],
    material: "925 Sterling Silver with Onyx",
    description: [
      "Slender abstract comet drops meet small black onyx stones at the huggie joint.",
      "Onyx, known as the stone of protection and strength, adds bold contrast and powerful energy.",
      "Perfect for those who love alternative style with a touch of celestial mystery.",
      "Versatile enough to make a statement with both casual and alternative fashion.",
      "Meticulously crafted to showcase the deep, mysterious beauty of the onyx stones.",
    ],
    Features: [
      "925 Sterling Silver material",
      "Genuine onyx gemstones",
      "Original abstract comet-drop design",
      "Secure hinged closure",
      "Bold, edgy aesthetic",
      "Hypoallergenic construction",
    ],
  },
  {
    id: 18,
    name: "Rising Arc Bracelet",
    category: "Bracelets",
    price: "66.00",
    reviews: "201",
    rating: "4.6",
    image: "/img/mefurvexo-18-front.png",
    images: ["/img/mefurvexo-18-front.png", "/img/mefurvexo-18-angle.png"],
    material: "925 Sterling Silver",
    description: [
      "A small open arc rises between two bead terminals on a fine adjustable silver chain.",
      "Perfect for those who appreciate meaningful symbols and love carrying a touch of good fortune.",
      "Timeless design that transcends trends, making it a lasting addition to any collection.",
      "Ideal as a thoughtful gift for graduations, new beginnings, or any special occasion.",
      "Crafted with care from premium sterling silver for lasting quality and meaning.",
    ],
    Features: [
      "925 Sterling Silver construction",
      "Original rising-arc design",
      "Two polished bead terminals",
      "Timeless and versatile",
      "Perfect for gifting",
      "Hypoallergenic properties",
    ],
  },
  {
    id: 19,
    name: "Nocturne Wing Ear Charms",
    category: "Earrings",
    price: "30.00",
    reviews: "276",
    rating: "4.8",
    image: "/img/mefurvexo-19-front.png",
    images: ["/img/mefurvexo-19-front.png", "/img/mefurvexo-19-angle.png"],
    material: "925 Sterling Silver",
    description: [
      "Abstract nocturnal wings combine asymmetrical open cells with a tiny crescent cutout.",
      "Moths symbolize transformation, intuition, and attraction to the light of knowledge.",
      "Perfect for those who love mystical, nature-inspired jewellery with deeper symbolism.",
      "Versatile design that can be added to hoops or worn as charms on their own.",
      "Intricately crafted to capture the delicate beauty and mystery of these nocturnal creatures.",
    ],
    Features: [
      "925 Sterling Silver material",
      "Original abstract wing design",
      "Tiny crescent cutout",
      "Intricate detailing",
      "Versatile charm style",
      "Hypoallergenic finish",
    ],
  },
  {
    id: 20,
    name: "Airlight Dragonfly Studs",
    category: "Earrings",
    price: "33.00",
    reviews: "189",
    rating: "4.6",
    image: "/img/mefurvexo-20-front.png",
    images: ["/img/mefurvexo-20-front.png", "/img/mefurvexo-20-angle.png"],
    material: "925 Sterling Silver",
    description: [
      "Abstract dragonfly studs pair curved bodies with softly mismatched open wings.",
      "Dragonflies represent transformation, self-realization, and living in the moment.",
      "Perfect for those undergoing life changes or who appreciate nature's delicate beauty.",
      "Lightweight and comfortable for everyday wear, adding subtle nature-inspired charm.",
      "Meticulously crafted to capture the graceful, ethereal quality of dragonflies in flight.",
    ],
    Features: [
      "925 Sterling Silver construction",
      "Original open-wing dragonfly design",
      "Symbol of transformation",
      "Secure push-back closure",
      "Lightweight and comfortable",
      "Hypoallergenic properties",
    ],
  },
];

export default productData;
